import { render, staticRenderFns } from "./viewExamcode.vue?vue&type=template&id=bda17024&scoped=true&"
import script from "./viewExamcode.vue?vue&type=script&lang=js&"
export * from "./viewExamcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda17024",
  null
  
)

export default component.exports